import { createAction } from 'redux-act';
import {
    ICreateThougth,
    IGetThougth,
    ILikeThougthResponse,
    IReactToThougth,
    ISetMediaUpload,
    IUpdateThougth,
    IUploadThougthMedia,
    types,
} from './types';
import { IGenericDocumentModifier, IThougth } from '../../types/global/helper';
import { IErrorType } from '../../constants/types';

export const createThought = createAction<ICreateThougth>(types.CREATE_THOUGTH);
export const createThoughtSuccess = createAction<IThougth>(types.CREATE_THOUGTH_SUCCESS);
export const createThoughtFail = createAction<IErrorType>(types.CREATE_THOUGTH_FAIL);

export const updateThougth = createAction<IUpdateThougth>(types.UPDATE_THOUGTH);
export const updateThougthSuccess = createAction<IThougth>(types.UPDATE_THOUGTH_SUCCESS);
export const updateThougthFail = createAction<IErrorType>(types.UPDATE_THOUGTH_FAIL);

export const deleteThougth = createAction<IGenericDocumentModifier>(types.DELETE_THOUGTH);
export const deleteThougthSuccess = createAction<IGenericDocumentModifier>(types.DELETE_THOUGTH_SUCCESS);
export const deleteThougthFail = createAction<IErrorType>(types.DELETE_THOUGTH_FAIL);

export const getThougth = createAction<IGetThougth>(types.GET_THOUGTH);
export const getThougthSuccess = createAction<IThougth>(types.GET_THOUGTH_SUCCESS);
export const getThougthFail = createAction<IErrorType>(types.GET_THOUGTH_FAIL);

export const getAllThougths = createAction(types.GET_ALL_THOUGTHS);
export const getAllThougthsSuccess = createAction<IThougth[]>(types.GET_ALL_THOUGTHS_SUCCESS);
export const getAllThougthsFail = createAction<IErrorType>(types.GET_ALL_THOUGTHS_FAIL);

export const uploadThougthMedia = createAction<IUploadThougthMedia>(types.UPLOAD_THOUGTH_MEDIA);
export const uploadThougthMediaSuccess = createAction<IThougth>(types.UPLOAD_THOUGTH_MEDIA_SUCCESS);
export const uploadThougthMediaFail = createAction<IErrorType>(types.UPLOAD_THOUGTH_MEDIA_FAIL);

export const likeThougth = createAction<IReactToThougth>(types.LIKE_A_THOUGTH);
export const likeThougthSuccess = createAction<ILikeThougthResponse>(types.LIKE_A_THOUGTH_SUCCESS);
export const likeThougthtFail = createAction<IErrorType>(types.LIKE_A_THOUGTH_FAIL);

export const deleteThougthLike = createAction<IGenericDocumentModifier>(types.DELETE_A_THOUGTH_LIKE);
export const deleteThougthLikeSuccess = createAction<IGenericDocumentModifier>(types.DELETE_A_THOUGTH_LIKE_SUCCESS);
export const deleteThougthLikeFail = createAction<IGenericDocumentModifier>(types.DELETE_A_THOUGTH_LIKE_FAIL);

export const publishThougth = createAction<string>(types.PUBLISH_THOUGTH);
export const publishThougthSuccess = createAction<IThougth>(types.PUBLISH_THOUGTH_SUCCESS);
export const publishThougthFail = createAction<IErrorType>(types.PUBLISH_THOUGTH_FAIL);

export const unpublishThougth = createAction<string>(types.UNPUBLISH_THOUGTH);
export const unpublishThougthSuccess = createAction<IThougth>(types.UNPUBLISH_THOUGTH_SUCCESS);
export const unpublishThougthFail = createAction<IErrorType>(types.UNPUBLISH_THOUGTH_FAIL);

export const setMediaUpload = createAction<ISetMediaUpload>(types.SET_UPLOAD_MEDIA);
export const completeMediaUpload = createAction<ISetMediaUpload>(types.COMPLETE_MEDIA_UPLOAD);
